<template>
  <v-row>
    <v-col cols="8" class="py-0 text-left font-weight-light">{{ title }}</v-col>
    <v-col cols="4" class="py-0 text-right font-weight-normal">{{ montant }}</v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: String,
    montant: String
  }
}
</script>

<style></style>